/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRef,
  LineItemRefOptional,
  LineItemRefMetaI,
  LineItemRefTrackedI,
} from "./line-item-ref";
import { LineItemRefTracked, LineItemRefMeta } from "./line-item-ref";

/**
 *
 * @export
 * @interface LineItemAvailableDiscount
 */
export interface LineItemAvailableDiscountOptional {
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemAvailableDiscount
   */
  lineItemId?: LineItemRefOptional;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  discountId?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  instanceId?: number;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemAvailableDiscount
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  percent?: string;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  discountName?: string;
}

export interface LineItemAvailableDiscount extends LineItemAvailableDiscountOptional {
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemAvailableDiscount
   */
  lineItemId?: LineItemRef;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  discountId?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  instanceId?: number;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemAvailableDiscount
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  percent?: string;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  discountName?: string;
}

export interface LineItemAvailableDiscountTrackedI {
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemAvailableDiscount
   */
  lineItemId?: LineItemRefTrackedI;
  lineItemIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  discountId?: number;
  discountIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemAvailableDiscount
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemAvailableDiscount
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemAvailableDiscount
   */
  discountName?: string;
  discountNameIsSet: boolean;
}

transformDatesMap.set(
  "LineItemAvailableDiscount",
  function (model: LineItemAvailableDiscount) {
    const transformDateslineItemId = transformDatesMap.get("LineItemRef");
    if (transformDateslineItemId && model.lineItemId) {
      transformDateslineItemId(model.lineItemId);
    }
  },
);

export type LineItemAvailableDiscountMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  lineItemId: PropertyMeta<LineItemRefMetaI>;
  //isDate: false
  //isDatetime: false
  discountId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var LineItemAvailableDiscountMeta: LineItemAvailableDiscountMetaI =
  {} as LineItemAvailableDiscountMetaI;
LineItemAvailableDiscountMeta = typeMeta("LineItemAvailableDiscount", {
  lineItemId: propertyMeta("lineItemId", false, false, false, LineItemRefMeta),
  discountId: propertyMeta(
    "discountId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  discountType: propertyMeta(
    "discountType",
    false,
    false,
    false,
    DiscountTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
  discountName: propertyMeta(
    "discountName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = LineItemAvailableDiscountMeta;

registerMeta(() => {});

export class LineItemAvailableDiscountTracked implements LineItemAvailableDiscountTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  lineItemId__I?: LineItemRefTracked = undefined;
  lineItemIdIsSet: boolean = false;
  set lineItemId(v: undefined | LineItemRefTracked) {
    if (v !== undefined) {
      this.lineItemId__I = v;
      this.lineItemIdIsSet = true;
    } else {
      this.lineItemId__I = v || undefined;
      this.lineItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItemId() {
    return this.lineItemId__I;
  }
  discountId__I?: number = undefined;
  discountIdIsSet: boolean = false;
  set discountId(v: undefined | number) {
    if (v !== undefined) {
      this.discountId__I = v;
      this.discountIdIsSet = true;
    } else {
      this.discountId__I = v || undefined;
      this.discountIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountId() {
    return this.discountId__I;
  }
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  discountName__I?: string = undefined;
  discountNameIsSet: boolean = false;
  set discountName(v: undefined | string) {
    if (v !== undefined) {
      this.discountName__I = v;
      this.discountNameIsSet = true;
    } else {
      this.discountName__I = v || undefined;
      this.discountNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountName() {
    return this.discountName__I;
  }
  constructor(
    config?: LineItemAvailableDiscountOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.lineItemId?.setIds();
  }
  assignFrom(
    config: LineItemAvailableDiscountOptional,
    options?: AssignOptions,
  ): LineItemAvailableDiscountTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.lineItemId &&
      this.lineItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.lineItemId = new LineItemRefTracked(config.lineItemId, options);
      if (optionsRequired.unassign) this.lineItemIdIsSet = false;
      else this.lineItemIdIsSet = true;
    }
    if (
      config.discountId &&
      this.discountIdApplyFilter(optionsRequired.filter)
    ) {
      this.discountId = config.discountId;
      if (optionsRequired.unassign) this.discountIdIsSet = false;
      else this.discountIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (
      config.discountName &&
      this.discountNameApplyFilter(optionsRequired.filter)
    ) {
      this.discountName = config.discountName;
      if (optionsRequired.unassign) this.discountNameIsSet = false;
      else this.discountNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemAvailableDiscountTrackedI {
    const cloned = {} as LineItemAvailableDiscountTrackedI;
    if (
      this.lineItemIdIsSetDeep() &&
      this.lineItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemIdIsSet = true;
      cloned.lineItemId = this.lineItemId?.removeUnset(filter);
    } else {
      //cloned.lineItemIdIsSet = false
    }
    if (
      this.discountIdIsSetDeep() &&
      this.discountIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountIdIsSet = true;
      cloned.discountId = this.discountId;
    } else {
      //cloned.discountIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.discountNameIsSetDeep() &&
      this.discountNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountNameIsSet = true;
      cloned.discountName = this.discountName;
    } else {
      //cloned.discountNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemAvailableDiscountTrackedI {
    if (!this.lineItemIdApplyFilter(filter)) this.lineItemIdIsSet = false;
    this.lineItemId?.unassignAll(filter);

    if (!this.discountIdApplyFilter(filter)) this.discountIdIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.discountNameApplyFilter(filter)) this.discountNameIsSet = false;

    return this;
  }
  lineItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.lineItemId,
      LineItemAvailableDiscountMeta,
      this.lineItemId,
      this,
    );
  }
  lineItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemIdIsSet && this.lineItemIdApplyFilter(filter)) return true;
    return this.lineItemId?.anySet(filter) == true;

    return false;
  }
  discountIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.discountId,
      LineItemAvailableDiscountMeta,
      this.discountId,
      this,
    );
  }
  discountIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountIdIsSet && this.discountIdApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.instanceId,
      LineItemAvailableDiscountMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.discountType,
      LineItemAvailableDiscountMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.amountCents,
      LineItemAvailableDiscountMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.percent,
      LineItemAvailableDiscountMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  discountNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemAvailableDiscountMeta.discountName,
      LineItemAvailableDiscountMeta,
      this.discountName,
      this,
    );
  }
  discountNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountNameIsSet && this.discountNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.lineItemIdIsSetDeep(filter)) return true;
    if (this.discountIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.discountNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
